function onConsentReady() {
  const cp = window.Shopify?.customerPrivacy;
  if (!cp) return;

  // 1) Handle already-saved consent on this page load:
  // These return true/false based on region + settings + consent.
  const canUsePrefs = cp.preferencesProcessingAllowed?.();
  const canUseMarketing = cp.marketingAllowed?.();

  if (canUsePrefs || canUseMarketing) {
        //startVideoLogic(); // (muted autoplay, then allow user to unmute on gesture)
        console.log("Consent given for preferences or marketing; starting video logic.");
  }

  // 2) Handle consent changes going forward:
  document.addEventListener("visitorConsentCollected", (event) => {
    // event.detail example includes: marketingAllowed, analyticsAllowed, preferencesAllowed, saleOfDataAllowed
    const d = event.detail;
    if (d.preferencesAllowed || d.marketingAllowed) {
        //startVideoLogic();
        console.log("New consent given for preferences or marketing; starting video logic.");
    }
  });

  const consentBannerWrapper = document.querySelector("#shopify-pc__banner");
  console.log("consentBannerWrapper: ", consentBannerWrapper);

  consentBannerWrapper?.addEventListener("click", function() {
    console.log("Consent banner clicked.");
    // You could also check specific buttons clicked here via event.target
  });
}

function loadConsentApiThenInit() {
  // If Shopify isn't on window yet (rare on normal themes, more common with async app loads),
  // wait until it is.
  if (!window.Shopify?.loadFeatures) {
    setTimeout(loadConsentApiThenInit, 50);
    return;
  }

  window.Shopify.loadFeatures(
    [{ name: "consent-tracking-api", version: "0.1" }],
    (error) => {
      if (error) {
        console.warn("Consent Tracking API failed to load:", error);
        return;
      }
      onConsentReady();
    }
  );
}

loadConsentApiThenInit();


/*document.addEventListener('visitorConsentCollected', (event) => {
        const consent = event.detail;
        console.log('Visitor consent collected:', consent);

        // Example structure:
        // consent.marketing
        // consent.analytics
        // consent.preferences

        if (consent.preferences || consent.marketing) {
        //startVideoLogic();
        }
    });

document.addEventListener('cookie-consent-loaded', function() {
    console.log('Cookie banner is loaded!');
    // Your code to run after banner is ready
});



document.addEventListener("visitorConsentCollected", (event) => console.log(event.detail));*/